<template>
  <div class="projects-warp">
    <div class="img-warp">
      <img src="../../assets/img/project-top.png" alt="" />
    </div>
    <div class="container">
      <div
        v-for="(item, index) in projectList"
        class="projects-section"
        :key="index"
      >
        <div class="project-type">
          {{ item.projectTypeName }}
        </div>
        <div class="project-content">
          <div
            v-for="(childItem, childIndex) in item.sysProjectDTOS"
            :key="childIndex"
            class="project-area"
            @click="handleClickProject(childItem)"
          >
            <div class="project-url">
              <img
                :src="childItem.projectIconUrl"
                class="project-url"
                alt="项目url"
              />
            </div>

            <div class="project-name">
              {{ childItem.projectName }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      list: [],
      projectList: [],
    };
  },

  computed: {
    ...mapState("user", {
      //项目id
      projects: (state) => state.projects,
    }),
  },

  created() {},

  mounted() {
    this.projectList = this.$deepClone(this.projects);
    this.checkCSOProject();
  },
  methods: {
    handleClickProject(project) {
      // let userInfo = JSON.parse(localStorage.getItem("CLOUD_RECORD"));
      let userInfo = JSON.parse(
        JSON.stringify(this.$store.state.user.loginForm)
      );
      delete userInfo.phoneNo;
      userInfo.projectId = project.id;
      this.$Api.loginInfo(userInfo).then((res) => {
        if (res.code == 0) {
          this.$store.commit("user/SET_CURRENT_PROJECT", project);
          this.$store.commit("user/SET_USERINFO", res.data);
          this.$router.push("/consult/list");
        }
      });
    },

    //查看是否有健康专员项目,id为5,如果有则添加cso项目
    checkCSOProject() {
      if (this.projects && this.projectList.length) {
        for (let i = 0; i < this.projectList.length; i++) {
          if (this.projectList[i].sysProjectDTOS) {
            let jkzyProject = this.projectList[i].sysProjectDTOS.find(
              (ele) => ele.id == 5
            );
            if (jkzyProject) {
              let csoProject = this.$deepClone(jkzyProject);
              csoProject.projectName = "CSO业务";
              csoProject.projectIconUrl = require("@/assets/img/icon-cso.png");
              this.projectList[i].sysProjectDTOS.push(csoProject);
              break;
            }
          }
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.projects-warp {
  width: 100%;
  min-height: 100vh;
  background: #0e0549;
  display: flex;
  flex-direction: column;
  img {
    width: 100%;
  }
  .container {
    min-height: calc(100vh - 95px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;

    .projects-section {
      box-sizing: border-box;
      width: 100%;
      margin-top: 40px;
      .project-type {
        margin-bottom: 24px;
        display: inline-block;
        box-sizing: border-box;
        padding: 11px 38px;
        height: 72px;
        background: #1c3769;
        border-radius: 48px;
        border: 1px solid #2f4f91;
        font-size: 36px;
        font-weight: 500;
        color: #c7fff0;
        line-height: 50px;
      }
      .project-content {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        .project-area {
          width: 200px;
          margin: 0 100px 50px 100px;
          margin-right: 100px;
          margin-left: 100px;
          .project-url {
            width: 100%;
            height: 200px;
            margin-bottom: 15px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .project-name {
            width: 100%;
            word-wrap: break-word;
            word-break: normal;
            font-size: 20px;
            font-weight: 500;
            color: #c7fff0;
            line-height: 29px;
          }
        }
      }
    }
  }
}
</style>
